/**
 * External dependencies
 */
import React from 'react';
import { Stack } from '@towersystems/towersystems-design-system';
import Notice from '../../../../components/notice';

/**
 * Internal dependencies
 */

const GunTradersRender = ({ ...props }) => {
	return (
		<Stack space='medium'>
			<Notice status='is-info' showDismiss={false} text='Location configuration not available for this connection type.' />
		</Stack>
	);
};

export default GunTradersRender;
